import * as yup from 'yup';
import FormFieldType from 'src/shared/ui/components/Form/FormFieldFactory/FormFieldType';

const getProductTypeList = (productTypeList, productCategoryList) => {
  return productTypeList.map((productType) => {
    const category = productCategoryList.filter(
      (x) => x.id === productType.productCategoryId
    )[0];
    const subcategory = productCategoryList.filter(
      (x) => x.id === productType.productSubcategoryId
    )[0];

    return {
      id: productType.id,
      name: `${productType.name} (${category.name}/${subcategory.name})`
    };
  });
};

const getProductType = (productTypeList, productCategoryList, fields) => {
  if (fields && fields.productTypeId) {
    let productTypeRaw = productTypeList.filter(
      (x) => x.id === fields.productTypeId
    )[0];

    const productType = {
      code: productTypeRaw.code,
      manufacturer: productTypeRaw.manufacturer,
      model: productTypeRaw.model,
      productCategoryId: productTypeRaw.productCategoryId,
      productSubcategoryId: productTypeRaw.productSubcategoryId
    };

    productType.categoryCode = productCategoryList.filter(
      (x) => x.id === productType.productCategoryId
    )[0].code;
    productType.subcategoryCode = productCategoryList.filter(
      (x) => x.id === productType.productSubcategoryId
    )[0].code;

    return JSON.stringify(productType);
  }
};

const getLocationOptions = (fields) => {
  let options = [
    { id: 'stock', name: 'Depósito' },
    { id: 'installer', name: 'Instalador' },
    { id: 'laboratory', name: 'Laboratorio' },
    { id: 'review', name: 'En revisión' }
  ];

  //if (fields && fields.location === 'installed') {
  options.push({ id: 'installed', name: 'Instalado' });
  //}

  return options;
};

const Inventory = ({
  fields,
  user,
  productTypeList,
  productCategoryList,
  userHeadquarterList,
  selectedUserHeadquarter
}) => [
  {
    name: 'companyHeadquarterId',
    validation: yup.string().nullable(false),
    type: FormFieldType.SELECT,
    value:
      fields && fields.companyHeadquarterId
        ? fields.companyHeadquarterId
        : selectedUserHeadquarter,
    options: userHeadquarterList.map((x) => {
      return { id: x.CompanyHeadquarter.id, name: x.CompanyHeadquarter.name };
    }),
    fullWidth: true
  },
  {
    name: 'code',
    validation: yup.string().nullable(true),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.code ? fields.code : '',
    fullWidth: false,
    hidden: fields && !fields.id,
    readonly: true
  },
  {
    name: 'productTypeId',
    validation: yup.string().nullable(true),
    type: FormFieldType.SELECT,
    value: fields && fields.productTypeId ? fields.productTypeId : '',
    options: getProductTypeList(productTypeList, productCategoryList),
    fullWidth: true,
    readonly: !user.scopes.includes('admin:inventory') && fields && !fields.id
  },
  {
    name: 'ProductType',
    validation: yup.string().nullable(true),
    type: FormFieldType.TEXT_FIELD,
    value: getProductType(productTypeList, productCategoryList, fields),
    hidden: true
  },
  {
    name: 'location',
    validation: yup.string().nullable(true),
    type: FormFieldType.SELECT,
    value: fields && fields.location ? fields.location : '',
    options: getLocationOptions(fields),
    fullWidth: true
  },
  {
    name: 'units',
    validation: yup
      .number()
      .nullable(false)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.units ? fields.units : '',
    fullWidth: false,
    enabled: fields && !fields.id
  },
  {
    name: 'identification',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.identification ? fields.identification : '',
    fullWidth: false,
    literal: 'InventoryIdentification',
    readonly: fields && fields.id
  },
  {
    name: 'serial',
    validation: yup.string(),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.serial ? fields.serial : '',
    readonly: fields && fields.id
  },
  {
    name: 'barCode',
    validation: yup.string().nullable(true),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.barCode ? fields.barCode : '',
    fullWidth: false
  },
  {
    name: 'expirationDate',
    validation: yup.date().nullable(true),
    type: FormFieldType.DATE,
    value: fields && fields.expirationDate ? fields.expirationDate : null
  },
  {
    name: 'description',
    validation: yup.string().nullable(true),
    type: FormFieldType.TEXT_AREA,
    value: fields && fields.description ? fields.description : '',
    fullWidth: true
  }
];

export default Inventory;
